import {
  readCustomer,
  readMessageTemplate,
  readPayment,
  readCardPayout,
  readLedgerPayment,
} from "@auth";
import {
  ArrowDownUp,
  ArrowRepeat,
  House,
  LightningCharge,
  ReceiptCutoff,
  People,
} from "react-bootstrap-icons";

import { PaperAirplaneIcon, PencilSquareIcon, ShieldExclamationIcon } from "@heroicons/react/24/outline";

// Helper to build navigation with dynamic customer groups
export const buildNavigation = (
  customerGroups = [],
  {
    customersCount = 0,
    requestTemplatesEnabled = false,
    openQueriesCount = 0,
    calendarEnabled = false,
    queriesEnabled = false,
    todaysTasksEnabled = false,
    todaysTasksCount = 0,
  } = {},
) => {
  const groupNavItems = customerGroups.map((group) => ({
    id: group.id,
    name: group.name,
    to: `/accounts/groups/${group.id}`,
    subAction: {
      icon: PencilSquareIcon,
      action: "editGroup",
    },
    count: group.membershipCount,
  }));

  const allAccountsItem = {
    name: "All accounts",
    to: "/accounts",
    count: customersCount,
    children: [
      ...groupNavItems,
      { name: "Create a group", action: "createGroup", icon: People },
    ],
  };

  // Home groups Today's tasks and Calendar, each behind its own feature flag. With both flags
  // off it has no children, so Home is dropped entirely rather than shown empty.
  const homeChildren = [
    todaysTasksEnabled && {
      name: "Today's tasks",
      to: "/tasks",
      count: todaysTasksCount || undefined,
    },
    calendarEnabled && { name: "Calendar", to: "/calendar" },
  ].filter(Boolean);

  return [
    homeChildren.length > 0 && {
      name: "Home",
      icon: House,
      // Surface the outstanding task count on the Home parent (orange circle, like Queries) so it's
      // visible without expanding the group.
      count: todaysTasksCount || undefined,
      children: homeChildren,
    },
    {
      name: "Trade Accounts",
      permission: readCustomer,
      icon: ReceiptCutoff,
      children: [allAccountsItem, { name: "Collections", to: "/collections" }],
    },
    {
      name: "Transactions",
      to: "/transactions",
      icon: ArrowDownUp,
      permission: readPayment,
    },
    {
      name: "Payment Requests",
      to: "/requests",
      icon: PaperAirplaneIcon,
    },
    {
      name: "Reconciliation",
      icon: ArrowRepeat,
      children: [
        { name: "Payouts", to: "/payouts", permission: readCardPayout },
        {
          name: "Ledger",
          to: "/ledgerpayments",
          permission: readLedgerPayment,
        },
      ],
    },
    queriesEnabled && {
      name: "Queries",
      to: "/queries",
      icon: ShieldExclamationIcon,
      permission: readCustomer,
      count: openQueriesCount || undefined,
    },
    !requestTemplatesEnabled && {
      name: "Automations",
      icon: LightningCharge,
      children: [
        {
          name: "Templates",
          to: "/templates",
          permission: readMessageTemplate,
        },
      ],
    },
  ].filter(Boolean);
};

// Default navigation for backward compatibility (empty groups)
export const navigation = buildNavigation();
